import React, { useContext, useState, useEffect } from "react";
import "../assets/css/layouts/deliveryPanel/DeliveryLayout.css";
import DeliverySidebar from "../components/deliveryPanel/deliverySidebar/DeliverySidebar";
import DeliveryTopbar from "../components/deliveryPanel/deliveryTopbar/DeliveryTopbar";
import MyContext from "../context/MyContext";

const DeliveryLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const { setAuthToken, setLoggedInDeliveryMan } = useContext(MyContext);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 991;
      setIsMobile(mobile);
      if (!mobile) setIsMobileOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
  const authToken = localStorage.getItem("authToken");
  setAuthToken(authToken);

  const deliveryMan = localStorage.getItem("loggedInDeliveryMan");

  if (deliveryMan && deliveryMan !== "undefined") {
    try {
      setLoggedInDeliveryMan(JSON.parse(deliveryMan));
    } catch (error) {
      console.error("Deliveryman data parse error:", error);
      localStorage.removeItem("loggedInDeliveryMan");
    }
  }
}, [setAuthToken, setLoggedInDeliveryMan]);

  return (
    <div className="del-layout">
      <DeliverySidebar
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
        isMobile={isMobile}
      />
      <div
        className={[
          "del-main",
          !isMobile && isCollapsed ? "del-main--collapsed" : "",
          isMobile ? "del-main--mobile" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <DeliveryTopbar
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          isMobileOpen={isMobileOpen}
          setIsMobileOpen={setIsMobileOpen}
          isMobile={isMobile}
        />
        <div className="del-content">{children}</div>
      </div>
    </div>
  );
};

export default DeliveryLayout;
